import React from 'react';
import * as Scrivito from 'scrivito';
import { findHomepage } from '../../lib/homepage';
import { requestInquiryTab } from '../../lib/inquiryTab';

Scrivito.provideWidgetClass('PricingWidget', {
  attributes: {
    title: 'string',
    main: 'string',
    subMain: 'string',
    firstLi: 'string',
    secondLi: 'string',
    thirdLi: 'string',
    linkText: 'string',
    link: 'string',
    flag: 'string',
  },
});

const PricingWidget = Scrivito.connect(({ widget }) => {
  const flag = widget.get('flag');

  // The Rails template ignored the widget's own `link` attribute (which is
  // empty in the CMS) and always pointed the button at the anchor in the
  // homepage's `button_3` – the inquiry form. Hiding the button when `link` was
  // blank dropped the "Angebot anfordern" call to action from both price boxes.
  const homepage = findHomepage(Scrivito.currentPage());
  const href = widget.get('link')
    || `#${(homepage && homepage.get('button_3')) || 'request_information'}`;

  return (
    <div className="pricing-simple popular">
      {flag && (
        <Scrivito.ContentTag tag="span" attribute="flag" content={widget} className="ribbon" />
      )}
      <Scrivito.ContentTag tag="h3" attribute="title" content={widget} className="pricing-title" />
      <div className="pricing-price">
        <Scrivito.ContentTag tag="span" attribute="main" content={widget} />
        <sub>
          <Scrivito.ContentTag tag="span" attribute="subMain" content={widget} />
        </sub>
      </div>
      <ul className="list-unstyled">
        <li>
          <i className="ti-eye" />
          <Scrivito.ContentTag tag="span" attribute="firstLi" content={widget} />
        </li>
        <li>
          <i className="ti-comments" />
          <Scrivito.ContentTag tag="span" attribute="secondLi" content={widget} />
        </li>
        <li>
          <i className="ti-alarm-clock" />
          <Scrivito.ContentTag tag="span" attribute="thirdLi" content={widget} />
        </li>
      </ul>
      <div className="bottom">
        <a
          id="offer-trigger-pricing"
          href={href}
          className="btn btn-lg trans-tech-blue-darker"
          onClick={() => requestInquiryTab('inquiry')}
        >
          <Scrivito.ContentTag tag="div" attribute="linkText" content={widget} />
        </a>
      </div>
    </div>
  );
});

Scrivito.provideComponent('PricingWidget', PricingWidget);

Scrivito.provideEditingConfig('PricingWidget', {
  title: 'Pricing Card',
  properties: ['flag', 'title', 'main', 'subMain', 'firstLi', 'secondLi', 'thirdLi', 'linkText', 'link'],
  attributes: {
    title:   { title: 'Plan Name' },
    main:    { title: 'Price (main)', description: 'e.g. "€ 0.09"' },
    subMain: { title: 'Price (unit)', description: 'e.g. "per word"' },
    firstLi:  { title: 'Feature 1' },
    secondLi: { title: 'Feature 2' },
    thirdLi:  { title: 'Feature 3' },
    linkText: { title: 'Button Label' },
    link:     { title: 'Button URL', description: 'Optional. Leave empty to link to the homepage\'s work-with-us section.' },
    flag:     { title: 'Ribbon Label', description: 'e.g. "Popular". Leave empty to hide.' },
  },
});

export default PricingWidget;
